export const initialState = {
  isLoading: false,
  pantry: [],
  shoppingList: [],
  selectedProducts: [],
};
